/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/DocumentDataExtractor.yaml

import { ScanbotDocumentDataExtractorImpl } from './impl';
import type { ImageInput, ResultWrapper } from './types/base/customTypes';
import type {
  DocumentDataExtractionResult,
  DocumentDataExtractorConfiguration,
  DocumentVerificationReport,
} from './types/core/document_data/DocumentDataExtractorTypes';
import type { GenericDocument } from './types/core/generic_document/GenericDocument';
import type { DocumentDataExtractorScreenConfiguration } from './types/core/ui_v2/document_data/DocumentDataExtractorScreenConfiguration';
import type { DocumentDataExtractorUiResult } from './types/core/ui_v2/document_data/DocumentDataExtractorUiResult';

/**
 * Entry point for all Document Data Extractor features.
 */
export const ScanbotDocumentDataExtractor = {
  /**
   * Opens the Ready-To-Use UI Document Data Extractor screen with the desired configuration.
   * @param {DocumentDataExtractorScreenConfiguration} configuration - The Document Data Extractor configuration to be used for extracting.
   * @returns {Promise<ResultWrapper<DocumentDataExtractorUiResult>>} - The result of the Document Data Extractor operation.
   */
  async startExtractorScreen(
    configuration: DocumentDataExtractorScreenConfiguration,
  ): Promise<ResultWrapper<DocumentDataExtractorUiResult>> {
    return ScanbotDocumentDataExtractorImpl.startExtractorScreen(configuration);
  },
  /**
   * Forces the Ready-To-Use UI Document Data Extractor screen to close if it is currently open.
   * @returns {Promise<void>}
   */
  async forceCloseExtractorScreen(): Promise<void> {
    return ScanbotDocumentDataExtractorImpl.forceCloseExtractorScreen();
  },
  /**
   * Extracts data from a given image with the desired configuration.
   * @param {ImageInput} params.image - The image to be used for extracting.
   * @param {DocumentDataExtractorConfiguration} params.configuration - The Document Data Extractor configuration to be used for extracting.
   * @returns {Promise<DocumentDataExtractionResult>} - The result of the Document Data Extractor operation.
   */
  async extractFromImage(params: {
    image: ImageInput;
    configuration: DocumentDataExtractorConfiguration;
  }): Promise<DocumentDataExtractionResult> {
    return ScanbotDocumentDataExtractorImpl.extractFromImage(params);
  },
  /**
   * Verifies document parts.
   * @param {GenericDocument[]} documentParts - The document parts to be used for verifying.
   * @returns {Promise<DocumentVerificationReport>} - The result of the Document Verification operation.
   */
  async verifyDocument(documentParts: GenericDocument[]): Promise<DocumentVerificationReport> {
    return ScanbotDocumentDataExtractorImpl.verifyDocument(documentParts);
  },
};
